module.exports = __webpack_public_path__ + "img/noplacelikehome12.75f901ae.jpg";